import React, { useContext, useEffect, useMemo, useState } from "react";
import { StatsContainer, StyledStats } from "../dashboard.style";
import TimeMenu from "./TimeMenu";
import StatsCard from "./StatsCard";
import StateContext from "../../../context/StateContext";
import useSegments from "../../../customHooks/useSegments";
import { useHistory } from "react-router-dom";
import { captureException } from "services/sentry";

const Stats = () => {
	const history = useHistory();
	const { getSegmentHits } = useSegments();
	const [timeSelected, setTimeSelected] = useState("LAST_7_DAYS");
	const [segmentHits, setSegmentHits] = useState(null);
	const { selectedSegmentCode, dispatch, ACTIONS, segments } = useContext(StateContext);

	// when time frame changes
	useEffect(() => {
		let didCancel = false;
		const updateData = async () => {
			try {
				if (!didCancel) {
					dispatch({ type: ACTIONS.SET_SPINNER, payload: true });
				}
				const { newHitsMap } = await getSegmentHits(timeSelected);
				if (newHitsMap && newHitsMap[selectedSegmentCode] && !didCancel) {
					dispatch({
						type: ACTIONS.SET_STATE,
						payload: { hitsMap: newHitsMap, showSpinner: false }
					});
					const hits = newHitsMap[selectedSegmentCode][timeSelected];
					setSegmentHits(hits);
				}
			} catch (e) {
				if (!didCancel) {
					dispatch({ type: ACTIONS.SET_SPINNER, payload: false });
				}
				console.error("Stats.js ~ updateData ~ error", e?.message || e);
				history.push({ pathname: "/error-page", state: e });
				captureException(e,"error",{},{ action: "useEffect", description: "Failed parsing stats" },{ scope: "Stats.js" });
			}
		};
		updateData();
		return () => {
			didCancel = true;
		};
	}, [timeSelected, selectedSegmentCode, segments]);

	const cardsContent = useMemo(() => {
		return [
			{
				tooltipContent: "A session is the period time a user is actively engaged with your website",
				cardTitle: "Sessions Analyzed",
				sessionNum: segmentHits?.total,
				changeRate: segmentHits?.totalChange
			},
			{
				tooltipContent: "The number of sessions that showed a basic level of engagement. Highly engaged sessions are included too",
				cardTitle: "Engaged Sessions",
				sessionNum: segmentHits?.Engaged,
				changeRate: segmentHits?.EngagedChange
			},
			{
				tooltipContent: "The number of sessions that showed a high level of engagement",
				cardTitle: "Highly Engaged Sessions",
				sessionNum: segmentHits?.highEngaged,
				changeRate: segmentHits?.highEngagedChange
			}
		];
	}, [segmentHits]);

	const selectTime = (e) => {
		const time_frame = e.target.getAttribute("value");
		setTimeSelected(time_frame);
	};

	const renderStats = () => {
		return cardsContent.map((card, index) => {
			return <StatsCard key={index} tooltipContent={card.tooltipContent} cardTitle={card.cardTitle} sessionNum={card.sessionNum} changeRate={card.changeRate} />;
		});
	};
	return (
		<StatsContainer>
			<TimeMenu selectTime={selectTime} timeSelected={timeSelected} />

			{segments ? <StyledStats>{renderStats()}</StyledStats> : <p>create and install a segment to see it's data</p>}
		</StatsContainer>
	);
};
export default Stats;
